export const SHOW_ONLY_ONCE_KEY = 'SHOWN_OLD_NATIVE_VERSION_DIALOG'
